import axios from "axios";
import { tokenRepo } from "../cache/db";
import { logoutHandler } from "../slices/loginSlice";
// Extend AxiosRequestConfig to allow Authorization header


const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  responseType: "json",
});

var isErrorShow = false;

apiClient.interceptors.request.use(
  async function (config) {
    const appToken = await tokenRepo.appToken.get(1);
    let header = {
      "content-type": config.headers.get("content-type")
        ? config.headers.get("content-type")
        : "application/json",
    };

    const token = appToken;

    if (token) {
      header = {
        ...header,
        Authorization: `Bearer ${token.token}`,
      };
    }
    if (config.skipHeader) {
      config.headers = {};
    } else {
      config.headers = header;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  
  function (response) {
    return response;
  },
  async function (error) {
    if(!isErrorShow){
      if(error.message == "Network Error"){
        alert("Network Error, Please check your internet connection");
        isErrorShow = true; 
      }
      if (error.response.status === 401) {
        alert("Something went wrong, Please login again and try");
        const { store } = await import("../store/store");
        store.dispatch(logoutHandler());
        isErrorShow = true; 
      }
      if(error.response.status === 403){
        alert("Session expired, Please login again and try");
        const { store } = await import("../store/store");
        store.dispatch(logoutHandler());
        isErrorShow = true; 
      }  
    }
    return Promise.reject(error);
  }
);
export default apiClient;
